import { createAction } from 'redux-actions';

export const snapshotCauses = createAction('CausesTracking/SNAPSHOT_CAUSES');

export const addDotCauses = createAction('CausesTracking/ADD_DOT_CAUSES');

export const markCauseSeen = createAction('CausesTracking/MARK_CAUSE_SEEN');

export const clearExpiredDots = createAction('CausesTracking/CLEAR_EXPIRED_DOTS');

export const resetSeenCauses = createAction('CausesTracking/RESET_SEEN_CAUSES');

export const setVisibleCausesCount = createAction('CausesTracking/SET_VISIBLE_CAUSES_COUNT');
